import script from "./TiktokLogoutDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./TiktokLogoutDialog.vue?vue&type=script&setup=true&lang=js"

import "./TiktokLogoutDialog.vue?vue&type=style&index=0&id=b957dd88&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b957dd88"]])

export default __exports__